// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l-main.m-maisoku{display:block;margin:0;max-width:100%;width:100%}.l-main.m-maisoku .l-main__wrap{padding-bottom:32px;padding-top:0;width:100%}@media screen and (max-width:767px){.l-main.m-maisoku .l-main__wrap{padding-bottom:45px;padding-top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
